<script setup>
import BaseLayout from '@/app/layouts/BaseLayout.vue';
import CFVerifyEmailAlert from '@/app/components/layout/CFVerifyEmailAlert.vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const route = useRoute();

const sidebarComponent = computed(() => route.meta?.sidebar || null);

const sidebarKey = computed(() => {
    const component = route.meta?.sidebar;
    return component?.name || component?.__name || null;
});
</script>

<template>
    <BaseLayout>
        <template #sidebar>
            <KeepAlive>
                <component
                    :is="sidebarComponent"
                    v-if="sidebarComponent"
                    :key="sidebarKey"
                />
            </KeepAlive>
        </template>

        <div
            class="min-w-0 flex-1"
            :class="sidebarComponent ? 'has-content-sidebar lg:pl-76' : ''"
        >
            <div class="main-container flex h-full flex-col overflow-y-auto">
                <CFVerifyEmailAlert />

                <slot />
            </div>
        </div>
    </BaseLayout>
</template>
